import React from 'react';
import { BookOpenIcon, CreditCardIcon, LockIcon, ZapIcon } from 'lucide-react';
type TrustVariant = 'hero' | 'final';
const items = {
  hero: [{
    icon: LockIcon,
    label: 'Secure Payment'
  }, {
    icon: ZapIcon,
    label: 'Instant Access'
  }, {
    icon: BookOpenIcon,
    label: '6 Volumes + 5 Bonuses'
  }],
  final: [{
    icon: LockIcon,
    label: 'Secure Checkout'
  }, {
    icon: ZapIcon,
    label: 'Instant Digital Access'
  }, {
    icon: CreditCardIcon,
    label: 'One-Time Payment'
  }]
};
export function TrustRow({
  variant = 'hero'
}: {
  variant?: TrustVariant;
}) {
  return <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-bold text-white/75 sm:text-sm" role="list" data-id="element-171" data-mp="1yxztpxjqht13">
      {items[variant].map(({
      icon: Icon,
      label
    }) => <li key={label} className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-172" data-mp="3ad4v8y84plj4">
          <Icon className="h-4 w-4 text-brand-lilac" aria-hidden="true" data-id="element-173" data-mp="3af9845o09uvj" />
          {label}
        </li>)}
    </ul>;
}